import { put } from "redux-saga/effects";
import { ManualTimeAction } from "../action";
import { Client } from "../../../utils/transport";
import { SOMETHING_WENT_WRONG } from "constants/staticText";
import { notification } from "antd";
import dayjs from "dayjs";
import { ExportCSV } from "utils/export-csv";
import { getDownloadTableViewColumns } from "utils/commonUtils";
import { calculateStartEndTimeDuration } from "utils/helper";

const ExportData = (
  fileName,
  data,
  colunms,
  filterDate,
  user_map_data,
  team_map_data,
  viewFields
) => {
  let result = [];
  const Generated = "Generated Date:-" + dayjs().format("DD-MM-YYYY hh:mm a");
  const generatedData = [
    fileName,
    // "Teams: - " + teams.join(",").replaceAll(",", "/"),
    "Date:-" + filterDate,

    Generated,
    colunms.join(),
  ];
  data.forEach((record) => {
    const user = user_map_data?.[record.created_by_id];
    const employeeName =
      user_map_data[record?.created_by_id]?.identity?.first_name +
      " " +
      user_map_data[record?.created_by_id]?.identity?.last_name;

    const dynamicValues = getDownloadTableViewColumns(
      viewFields,
      user,
      team_map_data
    );
    const fixedValues = [
      dayjs(record?.date).format("YYYY-MM-DD"),
      dayjs(record?.start_time, "HH:mm:ss").format("hh:mm A"),
      dayjs(record?.end_time, "HH:mm:ss").format("hh:mm A"),
      calculateStartEndTimeDuration(record?.start_time, record?.end_time),
      dayjs(record?.created_date).format("YYYY-MM-DD"),
      record?.app_policy_status,
      record?.summary,
      record?.status,
      record?.approval_remarks !== null ? record?.approval_remarks : "",
      record?.approver !== null
        ? record?.approver?.first_name + " " + record?.approver?.last_name
        : "",
    ];
    generatedData.push(
      [employeeName, ...dynamicValues, ...fixedValues].join(",")
    );
  });
  result = generatedData;
  return result;
};
const getDownloadCSV = (payload, data) => {
  const csvdata = data?.data;
  const date =
    dayjs(payload?.payload.body?.greaterThanOrEqualTo?.date).format(
      "YYYY-MM-DD"
    ) +
    " To " +
    dayjs(payload?.payload.body?.lessThanOrEqualTo?.date).format("YYYY-MM-DD");
  // Dynamic columns
  const dynamicFields = payload.payload.viewFields || [];
  const dynamicHeaders = dynamicFields.map((field) => field.label);

  // Fixed headers
  const fixedHeaders = [
    "Date",
    "Start Time",
    "End Time",
    "Duration",
    "Created date",
    "Time Attribution",
    "Summary",
    "Status",
    "Remark",
    "Approved by",
    "Rejected by",
  ];

  const finalHeaders = [
    "Employee", // full name
    ...dynamicHeaders,
    ...fixedHeaders,
  ];

  const exdata = ExportData(
    "Manual Time",
    csvdata,
    finalHeaders,
    date,
    // selectTeamNames,
    payload.payload.user_map_data,
    payload.payload.team_map_data,
    payload.payload.viewFields
  );

  ExportCSV("ManualTime_List_", exdata);
};

export function* fetchManualTimeSaga(action) {
  const queryString = Object.entries(action.payload.body)
    .map(([key, value]) => {
      if (typeof value === "object") {
        return Object.entries(value)
          .map(
            ([subKey, subValue]) =>
              `${key}[${subKey}]=${encodeURIComponent(subValue)}`
          )
          .join("&");
      } else {
        return `${key}=${encodeURIComponent(value)}`;
      }
    })
    .join("&");
  const config = {
    method: "POST",
    url: action.payload.isOwner
      ? `/api/v1/me/hierarchy/time_logs/search/?${queryString}`
      : `/api/v1/me/time_logs/search/`,

    headers: {
      ...action.payload.header,
    },
    data: !action.payload.isOwner ? action.payload.body : {},
  };
  try {
    const response = yield Client.request(config);
    yield put(ManualTimeAction.fetchManualTimeSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(ManualTimeAction.fetchManualTimeFailed(errorMessage));
  }
}

export function* createManualTimeSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/me/time_logs/`,
    headers: {
      ...action.payload.headers,
    },
    data: action.payload.body,
  };
  try {
    const response = yield Client.request(config);
    yield put(ManualTimeAction.createManualTimeSuccess(response.data));
    notification.success({
      message: `Successfully Created Manual Time!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(ManualTimeAction.createManualTimeFailed(errorMessage));
  }
}

export function* updateManualTimeSaga(action) {
  const config = {
    method: "POST",
    url: `/api/v1/me/hierarchy/time_logs/${action.payload.id}/approve/?approvalRemarks=${action.payload.approvalRemarks}&isRejected=${action.payload.isRejected}`,

    headers: {
      ...action.payload.headers,
    },
  };
  try {
    const response = yield Client.request(config);
    yield put(ManualTimeAction.updateManualTimeSuccess(response.data));
    notification.success({
      message: `Status Updated Successfully!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(ManualTimeAction.updateManualTimeFailed(errorMessage));
  }
}

export function* deleteManualTimeSaga(action) {
  const config = {
    method: "DELETE",
    url: `/api/v1/me/time_logs/${action.payload.id}`,
    headers: {
      ...action.payload.headers,
    },
  };
  try {
    yield Client.request(config);

    yield put(ManualTimeAction.deleteManualTimeSuccess());
    notification.success({
      message: `Successfully Deleted ManualTime!`,
    });
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(ManualTimeAction.deleteManualTimeFailed(errorMessage));
  }
}

export function* downloadManualTimeSaga(action) {
  const queryString = Object.entries(action.payload.body)
    .map(([key, value]) => {
      if (typeof value === "object") {
        return Object.entries(value)
          .map(
            ([subKey, subValue]) =>
              `${key}[${subKey}]=${encodeURIComponent(subValue)}`
          )
          .join("&");
      } else {
        return `${key}=${encodeURIComponent(value)}`;
      }
    })
    .join("&");
  const config = {
    method: "POST",
    url: action.payload.isOwner
      ? `/api/v1/me/hierarchy/time_logs/search/?${queryString}`
      : `/api/v1/me/time_logs/search/`,

    headers: {
      ...action.payload.header,
    },
    data: !action.payload.isOwner ? action.payload.body : {},
  };
  try {
    const response = yield Client.request(config);
    getDownloadCSV(action, response.data);

    yield put(ManualTimeAction.downloadManualTimeSuccess(response.data));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(ManualTimeAction.downloadManualTimeFailed(errorMessage));
  }
}
